/* eslint-disable filenames/match-regex */
import React from "react";
import PropTypes from "kf-proptypes/account";
import { Trans } from "@lingui/macro";

import { i18n } from "base/i18n";

import styles from "./quickHelp.css";

QuickHelp.propTypes = {
  type: PropTypes.string,
  content: PropTypes.objectOf(PropTypes.array)
};

export function QuickHelp(props) {
  return (
    <div className={styles.QuickHelpWrapper}>
      <p className={`h6 ${styles.QuickHelper}`}>
        <Trans>Quick help</Trans>
      </p>
      {props.content[props.type] &&
        props.content[props.type].map((value, index) => {
          return (
            <div key={index} className={styles.QuickHelpContentWrapper}>
              <p className={`base ${styles.qhTitle}`}>{i18n._(value.title)}</p>
              <p className={`smallplus ${styles.qhContentTxt}`}>
                {i18n._(value.content)}
              </p>
              {value.link && (
                <a
                  className={`small ${styles.qhContentLink}`}
                  href={value.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Trans>Read more</Trans>
                </a>
              )}
            </div>
          );
        })}
    </div>
  );
}
